/* Bonny & Rose (2026-09-18): geen voorgekozen maat.
   Het thema vinkt standaard de eerste maat (S) aan, waardoor één tik op
   "Add to cart" een maat 0-2 in de wagen legde. Nu staat er geen maat gekozen,
   de knop zegt "Select your size" en een tik zonder maat scrollt naar de
   maatknoppen en laat ze even oplichten. Een link met ?variant= (advertentie
   naar een specifieke maat) blijft zoals hij is. */
(function () {
  function init() {
    if (/[?&]variant=/.test(location.search)) return;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    Array.prototype.forEach.call(forms, function (form) {
      /* De maatknoppen staan in dit thema buiten het formulier, in hetzelfde
         productblok; daarom zoeken vanaf het blok, niet vanaf het formulier. */
      var blok = form.closest('.product-single__meta') || form.closest('[data-section-type]') || document;
      var wrap = blok.querySelector('.variant-input-wrap[data-handle="size"]');
      if (!wrap) return;
      var radios = wrap.querySelectorAll('input[type="radio"]');
      if (radios.length < 2) return;
      var btn = form.querySelector('button[name="add"]');
      if (!btn) return;
      var span = btn.querySelector('span') || btn;

      if (form.hasAttribute('data-br-user-picked')) return;
      Array.prototype.forEach.call(radios, function (r) { r.checked = false; });
      form.setAttribute('data-br-size-missing', '');
      span.textContent = 'Select your size';
      if (form.hasAttribute('data-br-size-wired')) return;
      form.setAttribute('data-br-size-wired', '');

      Array.prototype.forEach.call(radios, function (r) {
        r.addEventListener('change', function (e) {
          /* Het thema vuurt bij het opstarten zelf een change af; alleen een
             echte tik van haar telt als keuze. */
          if (e && e.isTrusted === false) return;
          form.setAttribute('data-br-user-picked', '');
          form.removeAttribute('data-br-size-missing');
          if (span.textContent.trim() === 'Select your size') span.textContent = 'Add to cart';
          /* Het thema schreef de knop al vóór ons; een kleine wijziging laat
             br-atc-price.js de prijs er weer bij zetten. */
          span.textContent = span.textContent.trim() + ' ';
        });
      });

      btn.addEventListener('click', function (e) {
        if (!form.hasAttribute('data-br-size-missing')) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        wrap.classList.add('br-size-flash');
        setTimeout(function () { wrap.classList.remove('br-size-flash'); }, 1600);
      }, true);
    });
  }
  /* Het thema zet na zijn eigen opstart de eerste maat opnieuw aan; daarom
     nog twee keer nalopen, maar nooit meer nadat zij zelf een maat koos. */
  function start() { init(); setTimeout(init, 400); setTimeout(init, 1500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
